/* Collapse the mobile search row while the shopper is scrolling down.
 *
 * Horizon already publishes the scroll direction on <header-component> as
 * data-scroll-direction, but keying the collapse straight off it in CSS
 * flickers badly. Removing the 46px search row shortens the document, Chrome's
 * scroll anchoring corrects scrollTop so the visible content does not jump,
 * and header.js reads that correction as a scroll in the opposite direction -
 * so the row reopens, the document grows, and it happens again. Measured at 50
 * height reversals on one downward swipe.
 *
 * Two guards break the loop:
 *   LOCK_MS     after a toggle, ignore the direction for longer than the CSS
 *               transition takes, which swallows the anchoring correction
 *   MIN_SCROLL  never toggle while the header is still crossing its own sticky
 *               boundary, where isAtTop flips and oscillates on its own
 *
 * The class is inert unless the header is in drawer mode: the desktop menu
 * layout puts the search inline in the header row with nothing to collapse, and
 * ce-tokens.css scopes the rules to [data-menu-style='drawer'] accordingly.
 */
const LOCK_MS = 520;
const MIN_SCROLL = 200;

function init() {
  const header = document.querySelector('header-component');
  if (!header) return;

  let lockedUntil = 0;
  let pending = null;
  let frame = null;

  const apply = () => {
    const now = performance.now();
    if (now < lockedUntil) {
      // re-check once the lock expires: the direction may have settled the
      // other way while we were ignoring it, and no further event is coming
      if (!pending) {
        pending = setTimeout(() => {
          pending = null;
          apply();
        }, lockedUntil - now + 20);
      }
      return;
    }

    const hide = header.dataset.scrollDirection === 'down' && window.scrollY > MIN_SCROLL;
    if (hide === header.classList.contains('ce-search-hidden')) return;

    header.classList.toggle('ce-search-hidden', hide);
    lockedUntil = performance.now() + LOCK_MS;
  };

  const onScroll = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      apply();
    });
  };

  // both: the attribute settles on its own rAF, and a long scroll in one
  // direction changes it only once, so scroll position has to be re-read too
  new MutationObserver(apply).observe(header, {
    attributes: true,
    attributeFilter: ['data-scroll-direction'],
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
